__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "eCareVault";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "2.39.0", () => (() => (__webpack_require__(16393))), 1);
			register("@azure/storage-blob", "^12.28.0", () => (() => (__webpack_require__(85188))), 1);
			register("@uirouter/angularjs", "0.3.2", () => (() => (__webpack_require__(89571))), 1);
			register("angucomplete-alt", "3.0.0", () => (() => (__webpack_require__(38593))), 1);
			register("angular-animate", "1.8.3", () => (() => (__webpack_require__(64271))), 1);
			register("angular-aria", "1.8.3", () => (() => (__webpack_require__(26257))), 1);
			register("angular-bootstrap-lightbox", "0.12.0", () => (() => (__webpack_require__(17424))), 1);
			register("angular-material-data-table", "0.10.10", () => (() => (__webpack_require__(91809))), 1);
			register("angular-material-time-picker", "1.0.8", () => (() => (__webpack_require__(49042))), 1);
			register("angular-material", "1.2.5", () => (() => (__webpack_require__(26805))), 1);
			register("angular-messages", "1.8.3", () => (() => (__webpack_require__(36064))), 1);
			register("angular-moment", "1.3.0", () => (() => (__webpack_require__(34415))), 1);
			register("angular-sanitize", "1.8.3", () => (() => (__webpack_require__(26415))), 1);
			register("angular-schema-form-bootstrap", "0.2.0", () => (() => (__webpack_require__(1817))), 1);
			register("angular-schema-form", "0.8.14", () => (() => (__webpack_require__(6723))), 1);
			register("angular-state-loader", "0.3.0", () => (() => (__webpack_require__(61661))), 1);
			register("angular-touch", "1.8.3", () => (() => (__webpack_require__(36751))), 1);
			register("angular-ui-bootstrap", "2.5.6", () => (() => (__webpack_require__(573))), 1);
			register("angular-ui-sortable", "0.19.0", () => (() => (__webpack_require__(39686))), 1);
			register("angular-utf8-base64", "0.0.5", () => (() => (__webpack_require__(83179))), 1);
			register("angular-validation-match", "1.9.0", () => (() => (__webpack_require__(81403))), 1);
			register("angular-validation", "1.4.1", () => (() => (__webpack_require__(69884))), 1);
			register("angular", "1.8.3", () => (() => (__webpack_require__(7025))), 1);
			register("echarts", "6.0.0", () => (() => (__webpack_require__(23209))), 1);
			register("file-saver", "1.3.8", () => (() => (__webpack_require__(91936))), 1);
			register("intl-tel-input", "12.1.15", () => (() => (__webpack_require__(30603))), 1);
			register("jquery", "3.7.1", () => (() => (__webpack_require__(74692))), 1);
			register("json-logic-js", "2.0.5", () => (() => (__webpack_require__(18678))), 1);
			register("jssha", "2.2.0", () => (() => (__webpack_require__(98399))), 1);
			register("moment", "2.30.1", () => (() => (__webpack_require__(95093))), 1);
			register("ng-file-upload", "12.2.13", () => (() => (__webpack_require__(78875))), 1);
			register("ng-focus-if", "1.0.7", () => (() => (__webpack_require__(48821))), 1);
			register("ng-idle", "1.3.2", () => (() => (__webpack_require__(99783))), 1);
			register("ng-table", "3.0.1", () => (() => (__webpack_require__(323))), 1);
			register("ngclipboard", "1.1.2", () => (() => (__webpack_require__(6362))), 1);
			register("objectpath", "1.2.2", () => (() => (__webpack_require__(8793))), 1);
			register("oclazyload", "1.1.0", () => (() => (__webpack_require__(63156))), 1);
			register("pdfjs-dist", "4.8.69", () => (() => (__webpack_require__(91100))), 1);
			register("toastr", "2.1.4", () => (() => (__webpack_require__(47959))), 1);
			register("tv4", "1.0.18", () => (() => (__webpack_require__(34048))), 1);
			register("video.js", "7.10.2", () => (() => (__webpack_require__(25989))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};